/* ===========================================================
   SPARKLÉVE — Global scripts
   Loaded once globally. Handles: scroll-reveal animations,
   FAQ accordion, mobile carousel arrows, demo video player,
   hero video lazy-load. Each block is guarded so it only runs
   when the relevant elements are on the page.
   =========================================================== */
(function(){
  'use strict';

  // ─── Scroll reveal ──────────────────────────────────────────
  if('IntersectionObserver' in window){
    var revealObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('v');
          revealObs.unobserve(e.target);
        }
      });
    }, {threshold:0.12, rootMargin:'0px 0px -30px 0px'});
    document.querySelectorAll('.spk-reveal').forEach(function(el){ revealObs.observe(el); });
  }

  // ─── FAQ accordion ──────────────────────────────────────────
  document.querySelectorAll('.spk-faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.parentElement;
      var wasOpen = item.classList.contains('open');
      // Close all in this faq group
      var group = btn.closest('.spk-faq-c') || document;
      group.querySelectorAll('.spk-faq-item.open').forEach(function(i){
        i.classList.remove('open');
        var b = i.querySelector('.spk-faq-q');
        if(b) b.setAttribute('aria-expanded','false');
      });
      if(!wasOpen){
        item.classList.add('open');
        btn.setAttribute('aria-expanded','true');
      }
    });
  });

  // ─── "Clean to Sparkling" italic-heading reveal ─────────────
  if('IntersectionObserver' in window){
    var ctsObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          var h = e.target.querySelector('h2');
          if(h){ h.style.opacity='1'; h.style.transform='translateY(0)'; }
          ctsObs.unobserve(e.target);
        }
      });
    }, {threshold:0.3});
    document.querySelectorAll('.spk-cts-text').forEach(function(el){ ctsObs.observe(el); });
  }

  // ─── Hero video lazy-attach (uploaded MP4 from Shopify) ─────
  (function(){
    var hv = document.querySelector('.spk-hero-video[data-src]');
    if(!hv) return;
    var isMobile = window.innerWidth <= 768;
    var src = isMobile
      ? (hv.getAttribute('data-src-mobile') || hv.getAttribute('data-src'))
      : hv.getAttribute('data-src');
    if(!src) return;
    var attached = false;
    function attach(){
      if(attached) return;
      attached = true;
      hv.setAttribute('autoplay', '');
      var s = document.createElement('source');
      s.src = src;
      s.type = 'video/mp4';
      hv.appendChild(s);
      hv.load();
      var p = hv.play();
      if(p && typeof p.catch === 'function') p.catch(function(){});
    }
    if('requestIdleCallback' in window){
      requestIdleCallback(attach, {timeout: 1500});
    } else {
      setTimeout(attach, 800);
    }
  })();

  // ─── Demo video player (click-to-play with overlay) ─────────
  document.querySelectorAll('.spk-demo-player').forEach(function(player){
    var demoVideo  = player.querySelector('.spk-demo-video');
    var demoOverlay= player.querySelector('.spk-demo-overlay');
    var demoCta    = player.querySelector('.spk-demo-cta-stack');
    var ctsHeading = player.querySelector('.spk-cts-text h2');
    var demoStarted = false;

    function playDemo(){
      if(!demoVideo) return;
      demoVideo.style.opacity = '1';
      demoVideo.style.pointerEvents = 'auto';
      if(demoOverlay){demoOverlay.style.opacity = '0';demoOverlay.style.pointerEvents = 'none';}
      if(demoCta){ demoCta.style.opacity = '0'; demoCta.style.pointerEvents = 'none'; }
      if(ctsHeading) ctsHeading.style.opacity = '0';
      var p = demoVideo.play();
      if(p && typeof p.catch === 'function') p.catch(function(){});
      demoStarted = true;
    }
    function restoreOverlay(){
      if(!demoVideo) return;
      demoVideo.style.opacity = '0';
      demoVideo.style.pointerEvents = 'none';
      if(demoOverlay) demoOverlay.style.opacity = '1';
      if(demoCta){ demoCta.style.opacity = '1'; demoCta.style.pointerEvents = 'auto'; }
      if(ctsHeading) ctsHeading.style.opacity = '1';
      demoStarted = false;
    }
    player.addEventListener('click', function(){ if(!demoStarted) playDemo(); });
    player.addEventListener('keydown', function(e){
      if(demoStarted) return;
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); playDemo(); }
    });
    if(demoVideo) demoVideo.addEventListener('ended', restoreOverlay);
  });

  // ─── Mobile product-carousel arrows ─────────────────────────
  document.querySelectorAll('.spk-prod-carousel').forEach(function(wrap){
    var prodGrid = wrap.querySelector('.spk-prod-grid');
    var leftBtn  = wrap.querySelector('.spk-mob-shop-l');
    var rightBtn = wrap.querySelector('.spk-mob-shop-r');
    if(!prodGrid || !leftBtn || !rightBtn) return;
    leftBtn.addEventListener('click', function(){
      prodGrid.scrollBy({left: -window.innerWidth, behavior: 'smooth'});
    });
    rightBtn.addEventListener('click', function(){
      prodGrid.scrollBy({left: window.innerWidth, behavior: 'smooth'});
    });
  });
})();
